import { cwslapi } from "./index";
import Cookies from 'js-cookie'


//  获取用户信息
export const getMemberInfoApi = (data) => {
  return cwslapi({
    url: "/user/getMemberInfo",
    method: "post",
    data,
  });
};

// 登录状态下获取手机验证码---发送短信
export const getsendMsgTouser = (data) => { 
  return cwslapi({
    url: "/sms/sendMsgTouser",// 短信类型；1：注册，2：找回密码，3：修改密码 4：修改手机号,5：新绑定手机号，6：划分白金币发送短信,7:找回账号,8:修改昵称
    method: "post",
    data,
  });
};

// 获取大区列表
export const getServerList = (data) => { 
  return cwslapi({
    url: "/public/getServerList",
    method: "post",
    data,
  });
};

// 退出
export const getlogout = (data) => { 
  return cwslapi({
    url: "/login/logout?source=web&userId=" + Cookies.get('cwsl_userId'),
    method: "post",
    data,
  });
};

// 未登录状态下获取手机验证码
export const getregisterSendMsg = (data) => {
  return cwslapi({
    url: '/sms/sendMsg',
    method: 'post',
    data
  })
}


// 获取首页轮播图片
export const getBannerListApi = () => {
  return cwslapi({
    url: '/public/getBannerList',
    method: 'get'
  })
}